import type { InputHTMLAttributes } from 'react';
import React from 'react';

import * as styles from './Checkbox.styles';
import { IconCheckmark } from 'client-ribbons-design-system/components/foundations/Iconography/IconCheckmark';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {}

export const Checkbox = (props: CheckboxProps) => {
  const checkmarkStyles = [styles.checkmark, props.checked && styles.checkmarkChecked];

  return (
    <div css={styles.container}>
      <input css={styles.input} {...props} type="checkbox" />
      <IconCheckmark color={'var(--neutral-white-base)'} css={checkmarkStyles} />
    </div>
  );
};
